import React from "react";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ReactComponent as BaseCorp } from "../../../../myfin_v2/assets/icons/companylogo.svg";
import { ReactComponent as CardEditIcon } from "../../../../myfin_v2/assets/icons/editCard.svg";
import { ReactComponent as CloseSideModel } from "../../../../myfin_v2/assets/icons/closeSideModel.svg";
import { ReactComponent as CategoryRightArrow } from "../../../../myfin_v2/assets/icons/categoryRightArrow.svg";
import { ReactComponent as AddCategoryBtn } from "../../../../myfin_v2/assets/icons/addCategoryBtn.svg";
import { ReactComponent as CreateNewCategoryBtn } from "../../../../myfin_v2/assets/icons/createNewCategoryBtn.svg";
import { ReactComponent as RemoveIcon } from "../../../../myfin_v2/assets/icons/removeLoansIcons.svg";
import CompanyEditSideMenu from "../CompanyEditSideMenu";
import Breadcrumb from "../../../components/Breadcrumb";
import commoncss from "../../../css/common.module.css";
import sidemenucss from "../../../css/sidemenu.module.css";
import DefinitionsCss from "../../../css/definitions.module.css";

import HeaderWhenSecondSideBarActive from "../../../elements/HeaderWhenSecondSideBarActive";
import { Description } from "@material-ui/icons";

import Select from "react-select";

import {
  getAllStaging,
  createNewStaging,
  updateStaging,
  deleteStaging,
  getAllCategoryReceivable,
  createNewCategoryReceivable,
  updateCategoryReceivable,
  deleteCategoryReceivable,
  subReceivablemapping,
  //  createNewStaging
} from "../../../../Bookclosure/Services/ApiHandler";

import swal from "sweetalert";
import { toast } from "react-toastify";
import { useLocation } from "react-router";

const ReceivablesDefinitions = () => {
  const [categoryData, setCategoryData] = useState([]);

  const { companyId } = useParams();
  const [companyID, setCompanyID] = useState(companyId);
  const location = useLocation();
  const receivablesID = location.state?.receivablesID || null;
  // const [companyID, setCompanyID] = useState('6655b5365ce609ea146c5c53');  // Example company ID
  const [createOrUpdate, setCreateOrUpdate] = useState("C");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");

  useEffect(() => {
    fetchDefinitionsCategoryData(companyID, setCategoryData);
  }, [companyID]);

  const fetchDefinitionsCategoryData = async (companyID, setCategoryData) => {
    try {
      const response = await getAllCategoryReceivable(companyID);
      const cateGoryDt = response.data.categoryList;
      setCategoryData(cateGoryDt);
    } catch (err) {
      console.error("Failed to fetch data", err);
    }
  };

  const [companyName, setcompanyName] = useState(""); 

  const breadcrumbItems = [
    {
      label: "My companies",
      link: `/myfinV2/my-companies`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: companyName,
      link: `/myfinV2/company-details/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Definitions",
      link: `/myfinV2/definitions/${companyID}`,

      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Receivables Categorization",
      link: `/myfinV2/receivables-definitions/${companyID}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    // ...(selectedCategoryName
    //   ? [
    //       {
    //         label: selectedCategoryName,
    //         className: `${commoncss.nav_cnt_color}`,
    //       },
    //     ]
    //   : []),
  ];

  const [stagingTabOrCategoryTab, setstagingTabOrCategoryTab] =
    useState("staging");

  const [activeTab, setActiveTab] = useState("tab2");

  const [createTab, setCreateTab] = useState("I");

  const [categories, setCategories] = useState([
    {
      categoryName: "",
      subCategories: [
        {
          subCategoryName: "",
          subSubCategories: [""],
        },
        {
          subCategoryName: "",
          subSubCategories: [],
        },
      ],
    },
  ]);

  // ================

  function resetCreateModel(stageOrcategory) {
    if (stageOrcategory === "category") {
      setCategories([
        {
          categoryName: "",
          subCategories: [
            { subCategoryName: "", subSubCategories: [""] },
            { subCategoryName: "", subSubCategories: [] },
          ],
        },
      ]);
    }
  }

  return (
    <div className={`${DefinitionsCss.subContainer}`}>
      <CompanyEditSideMenu
        activeTab={"Definitions"}
        companyID={companyID}
        companyDataCheck={true}
        setcompanyName={setcompanyName}
        subMenuItem={"Receivable Regiser"}
      />

      <div className={DefinitionsCss.subContainer__}>
        <div className={DefinitionsCss.headerWrapper}>
          <Breadcrumb
            addCls="bgTransprent"
            items={breadcrumbItems}
            headerActions={<></>}
            p0={true}
          />
          <div>
            <button
              type="button"
              className={`${DefinitionsCss.createStagingBtn} ${
                createTab === "A" ? DefinitionsCss.disableCreateBtn : ""
              }`}
              disabled={createTab === "A"}
              onClick={() => {
                if (activeTab === "tab1") {
                  setCreateTab("A");
                  setstagingTabOrCategoryTab("staging");
                  setCreateOrUpdate("C");
                  resetCreateModel("staging");
                } else if (activeTab === "tab2") {
                  setCreateTab("A");
                  setstagingTabOrCategoryTab("category");
                  setCreateOrUpdate("C");
                  resetCreateModel("category");
                }
              }}
            >
              Create New Category
            </button>
          </div>
        </div>

        <MulitTabsContainer
          companyID={companyID}
          categoryData={categoryData}
          setCategoryData={setCategoryData}
          createOrUpdate={createOrUpdate} // Pass createOrUpdate
          setCreateOrUpdate={setCreateOrUpdate}
          // ===========
          resetCreateModel={resetCreateModel}
          categories={categories}
          setCategories={setCategories}
          createTab={createTab}
          setCreateTab={setCreateTab}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          receivablesID={receivablesID}
          stagingTabOrCategoryTab={stagingTabOrCategoryTab}
          setstagingTabOrCategoryTab={setstagingTabOrCategoryTab}
          setSelectedCategoryName={setSelectedCategoryName}
        />
      </div>
    </div>
  );
};

export default ReceivablesDefinitions;

const MulitTabsContainer = ({
  stagingData,
  categoryData,
  companyID,
  setStagingData,
  setCategoryData,
  createOrUpdate, // Receive createOrUpdate from the parent
  setCreateOrUpdate,

  // ===============
  resetCreateModel,
  categories,
  setCategories,
  createTab,
  setCreateTab,
  receivablesID,
  activeTab,
  setActiveTab,
  setSelectedCategoryName,
  stagingTabOrCategoryTab,
  setstagingTabOrCategoryTab,
}) => {
  const [upadteSelectedCategory, setupadteSelectedCategory] = useState("");

  useEffect(() => {
    if (categoryData.length > 0) {
      const mappedCategories = categoryData.map((cat) => ({
        categoryName: cat.name,
        _id: cat._id,
        subCategories: cat.subcategory.map((sub) => ({
          subCategoryName: sub.name,
          _id: sub._id,
          subSubCategories: (sub.subcategory || []).map((ss) => ss.name),
        })),
      }));

      // setCategories(mappedCategories); //  Now your form has ID info too
    }
  }, [categoryData]);

  const removeSubCategory = (catIdx, subIdx) => {
    const updated = [...categories];
    updated[catIdx].subCategories.splice(subIdx, 1);
    setCategories(updated);
  };

  const removeSubSubCategory = (catIdx, subIdx, ssIdx) => {
    const updated = [...categories];
    updated[catIdx].subCategories[subIdx].subSubCategories.splice(ssIdx, 1);
    setCategories(updated);
  };

  const addSubCategory = (catIdx) => {
    const updated = [...categories];
    updated[catIdx].subCategories.push({
      subCategoryName: "",
      subSubCategories: [],
    });
    setCategories(updated);
  };

  const addSubSubCategory = (catIdx, subIdx) => {
    const updated = [...categories];
    updated[catIdx].subCategories[subIdx].subSubCategories.push("");
    setCategories(updated);
  };

  // function resetCreateModel(stageOrcategory){

  //     // default input formate
  //     if(stageOrcategory == 'category'){
  //         setCategories([
  //             {
  //                 categoryName: '',
  //                 subCategories: [
  //                 {
  //                     subCategoryName: '',
  //                     subSubCategories: ['']
  //                 },

  //                 {
  //                     subCategoryName: '',
  //                     subSubCategories: []
  //                 }

  //                 ]
  //             }
  //         ])
  //     }

  // }

  function FillTheCategoryInputFieldsWithSelectedCategory(categoryId) {
    setCreateTab("A");
    setstagingTabOrCategoryTab("category");

    const categoryDt = categoryData.find((item) => item._id === categoryId);

    if (categoryDt) {
      const formatted = {
        categoryName: categoryDt.name,
        _id: categoryDt._id,
        subCategories: categoryDt.subcategory.map((sub) => ({
          subCategoryName: sub.name,
          _id: sub._id,
          subSubCategories: sub.subcategory?.map((subsub) => subsub.name) || [],
        })),
      };
      setCategories([formatted]);
    }
  }

  // const buildFinalJson = () => {
  //     const result = {
  //         category: categories
  //             .filter(cat => cat.categoryName?.trim()) // Skip empty category names
  //             .map(cat => ({
  //                 // _id: upadteSelectedCategory,
  //                 name: cat.categoryName.trim(),
  //                 subcategory: cat.subCategories
  //                     .filter(sub => sub.subCategoryName?.trim()) // Skip empty subcategory names
  //                     .map(sub => ({
  //                         name: sub.subCategoryName.trim(),
  //                         subcategory: sub.subSubCategories
  //                             .filter(ss => ss?.trim()) // Skip empty sub-subcategory names
  //                             .map(ss => ({
  //                                 name: ss.trim()
  //                             }))
  //                     }))
  //             }))
  //     };

  //     return result.category[0]; // or send whole array if needed
  // };
  const buildFinalJson = () => {
    const result = {
      category: categories
        .filter((cat) => cat.categoryName?.trim()) // Skip empty categories
        .map((cat) => {
          const catData = {
            name: cat.categoryName.trim(),
            subcategory: cat.subCategories
              .filter((sub) => sub.subCategoryName?.trim()) // Skip empty subcategories
              .map((sub) => {
                const subData = {
                  name: sub.subCategoryName.trim(),
                  subcategory: sub.subSubCategories
                    .filter((ss) => ss?.trim()) // Skip empty sub-subcategories
                    .map((ss) => ({ name: ss.trim() })),
                };

                if (sub._id) subData._id = sub._id; // add _id only if it exists
                return subData;
              }),
          };

          if (cat._id) catData._id = cat._id; // add category _id only if it exists
          return catData;
        }),
    };

    console.log("Filtered JSON:", result);
    return result.category[0]; // or return full list if needed
  };

  const getCategoryDataSendToApi = (createOrUpdate_) => {
    // Create category
    if (createOrUpdate_ === "C") {
      const finalData = buildFinalJson();

      createNewCategoryReceivable(companyID, finalData)
        .then((response) => {
          toast.success("Category Created Successfully.");
          getAllCategoryReceivable(companyID).then((response) => {
            const categoryDt = response.data.categoryList;
            setCategoryData(categoryDt);
          });

          // making category fields to empty
          setCategories([
            {
              categoryName: "",
              subCategories: [
                {
                  subCategoryName: "",
                  subSubCategories: [""],
                },

                {
                  subCategoryName: "",
                  subSubCategories: [],
                },
              ],
            },
          ]);
        })
        .catch((error) => {
          swal(
            "Error",
            error.response?.data?.error || "Saving new category!",
            "error"
          );
        });
    } else if (createOrUpdate_ === "U") {
      const finalCategoryMapping = buildFinalJson();

      updateCategoryReceivable(companyID, finalCategoryMapping)
        .then((response) => {
          toast.success("Updated Category Successfully.");

          subReceivablemapping(receivablesID, {
            categorySubmap: finalCategoryMapping.subcategory.map((sub) => ({
              key: sub.name,
              values: sub.subcategory.map((ss) => ss.name),
            })),
          });

          getAllCategoryReceivable(companyID).then((response) => {
            const categoryDt = response.data.categoryList;
            setCategoryData(categoryDt);
          });
        })
        .catch((error) => {
          swal(
            "Error",
            error.response?.data?.error || "updating category!",
            "error"
          );
        });
    }
     else if (createOrUpdate_ === "D") {
     const categoryToDelete = buildFinalJson();
     const categoryId = categoryToDelete._id;

     if (!categoryId) {
      swal("Error", "Category ID not found!", "error");
      return;
     }

     deleteCategoryReceivable(companyID, categoryId)
      .then((response) => {
        toast.success("Category Deleted Successfully.");
        
        getAllCategoryReceivable(companyID).then((response) => {
          const categoryDt = response.data.categoryList;
          setCategoryData(categoryDt);
        });

        setCategories([
          {
            categoryName: "",
            subCategories: [
              {
                subCategoryName: "",
                subSubCategories: [""],
              },
              {
                subCategoryName: "",
                subSubCategories: [],
              },
            ],
          },
        ]);
        
      })
      .catch((error) => {
        swal(
          "Error",
          error.response?.data?.error || "deleting category!",
          "error"
        );
      });
    }
  };

  return (
    <div className={DefinitionsCss.subMainContainer}>
      <div
        className={
          createTab == "A"
            ? DefinitionsCss.tabContainerSideContainer
            : DefinitionsCss.tabContainer
        }
      >
        <div className={DefinitionsCss.tabsContainer}>
          {/* <div onClick={ () => {setActiveTab('tab1'); setCreateTab('I')} } className={`${DefinitionsCss.btn} ${ activeTab === 'tab1' ? DefinitionsCss.btnActiveFirst : '' }`}>Define Staging</div> */}
          <div
            onClick={() => {
              setActiveTab("tab2");
              setCreateTab("I");
            }}
            className={`${DefinitionsCss.btn} ${
              activeTab === "tab2" ? DefinitionsCss.btnActiveFirst : ""
            }`}
          >
            Define Category
          </div>
        </div>

        {activeTab === "tab1" && (
          <div className={DefinitionsCss.tabContantContainer}>
            <div className={DefinitionsCss.tabHeaderContainer}>
              <button
                onClick={() => {
                  setCreateTab("A");
                  setstagingTabOrCategoryTab("staging");
                  setCreateOrUpdate("C");
                  resetCreateModel("staging");
                }}
                className={DefinitionsCss.Btn}
              >
                Create New Stage
              </button>
            </div>

            <div className={DefinitionsCss.cardsContainer}>
              {/* Staging card */}
            </div>
          </div>
        )}

        {activeTab === "tab2" && (
          <div className={DefinitionsCss.tabContantContainer}>
            {/* <div className={DefinitionsCss.tabHeaderContainer}> 
                    <button onClick={() => { setCreateTab('A'); setstagingTabOrCategoryTab('category'); setCreateOrUpdate('C'); resetCreateModel('category'); }} className={DefinitionsCss.Btn}>Create New Category</button>
                    </div>  */}
            <div className={DefinitionsCss.cardsContainer}>
              {/* Category card */}

            <button
              className={`${DefinitionsCss.createNewCategoryButton} ${
                createTab == "A"
                  ? DefinitionsCss.cardContainerSideContainerCreateCard
                  : DefinitionsCss.cardContainerSideContainerCreateCardActiveSide
              }`}
              onClick={() => {
                setCreateTab("A");
                setstagingTabOrCategoryTab("category");
                setCreateOrUpdate("C");
                resetCreateModel("category");
              }}
            >
              Create new  <br/>Category
            </button>

              {categoryData.map((category) => (
                <div
                  className={
                    createTab == "A"
                      ? DefinitionsCss.cardContainerSideContainer
                      : DefinitionsCss.cardContainer
                  }
                  key={category._id}
                  onClick={() => {
                    setupadteSelectedCategory(category._id);
                    setSelectedCategoryName(category.name);
                    FillTheCategoryInputFieldsWithSelectedCategory(
                      category._id
                    );
                    setCreateOrUpdate("U");
                  }}
                >
                  <div className={DefinitionsCss.cardHeader}>
                    <div
                      className={
                        createTab == "A"
                          ? DefinitionsCss.CardTitleSideContainer
                          : DefinitionsCss.CardTitle
                      }
                    >
                      {category.name}
                    </div>
                    <div>
                      <CardEditIcon
                        className={
                          createTab == "A"
                            ? DefinitionsCss.editIconSizeSideContainer
                            : DefinitionsCss.editIconSize
                        }
                      />
                    </div>
                  </div>

                  <div
                    className={
                      createTab == "A"
                        ? DefinitionsCss.cardDescSideContainer
                        : DefinitionsCss.cardDesc
                    }
                  >
                    <CategoryRightArrow
                      className={
                        createTab == "A"
                          ? DefinitionsCss.editIconSizeSideContainer
                          : DefinitionsCss.editIconSize
                      }
                    />
                    &nbsp;
                    {category.subcategory && category.subcategory.length > 0 ? (
                      <>
                        {category.subcategory.slice(0, 2).map((sub, idx) => (
                          <span key={idx} className={DefinitionsCss.childName} title={sub.name}>
                            {sub.name}
                            {idx < Math.min(1, category.subcategory.length - 1)
                              ? ", "
                              : ""}
                          </span>
                        ))}
                        {category.subcategory.length > 2 &&
                          ` +${category.subcategory.length - 2} more`}
                      </>
                    ) : (
                      "No subcategories"
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {createTab == "A" ? (
        <>
          {}

          {stagingTabOrCategoryTab == "category" ? (
            <div className={DefinitionsCss.CreateContainer}>
              <div className={DefinitionsCss.sideModelHeader}>
                <div className={DefinitionsCss.sideModelTitle}>
                  {createOrUpdate == "C"
                    ? "Create New Category"
                    : "Update Category"}
                </div>
                <CloseSideModel
                  className={sidemenucss.sideModelCloseIcon}
                  onClick={() => setCreateTab("I")}
                  style={{ cursor: "pointer" }}
                />
              </div>

              {categories.map((cat, catIdx) => (
                <div key={catIdx}>
                  <div className={DefinitionsCss.InptContainer}>
                    <div className={DefinitionsCss.inptLabelContainer}>
                      <span className={DefinitionsCss.Inptlabel}>
                        Category Name
                      </span>
                      <span
                        className={DefinitionsCss.InptActionlabel}
                        onClick={() => addSubCategory(catIdx)}
                        style={{ cursor: "pointer" }}
                      >
                        Add Sub Category
                      </span>
                    </div>
                    <input
                      className={DefinitionsCss.inpt}
                      type="text"
                      placeholder="Category Name"
                      value={cat.categoryName || ""}
                      onChange={(e) => {
                        const newCats = [...categories];
                        newCats[catIdx].categoryName = e.target.value;
                        setCategories(newCats);
                      }}
                    />
                  </div>

                  <div
                    className={DefinitionsCss.categoryScrollContainer}
                    // style={{ overflowY: 'scroll', height: '65vh', marginBottom: '60px' }}
                  >
                    {cat.subCategories.map((sub, subIdx) => (
                      <div key={subIdx}>
                        <div className={DefinitionsCss.InptContainer}>
                          <div className={DefinitionsCss.inptLabelContainer}>
                            <span className={DefinitionsCss.Inptlabel}>
                              <CategoryRightArrow
                                className={DefinitionsCss.editIconSize}
                              />
                              &nbsp; Sub - Category Name
                            </span>
                            <span
                              onClick={() => addSubSubCategory(catIdx, subIdx)}
                              className={DefinitionsCss.InptActionlabel}
                              style={{ cursor: "pointer" }}
                            >
                              Add Child Category
                            </span>
                          </div>
                          <div
                            className={DefinitionsCss.subCategoryInptContainer}
                          >
                            <input
                              className={DefinitionsCss.SubCategoryInpt}
                              type="text"
                              placeholder="SubCategory Name"
                              value={sub.subCategoryName} // Bind to subcategory name
                              onChange={(e) => {
                                const newCats = [...categories];
                                newCats[catIdx].subCategories[
                                  subIdx
                                ].subCategoryName = e.target.value;
                                setCategories(newCats);
                              }}
                            />{" "}
                            <RemoveIcon
                              className={DefinitionsCss.removeIcon}
                              onClick={() => removeSubCategory(catIdx, subIdx)}
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </div>

                        {sub.subSubCategories.map((ss, ssIdx) => (
                          <div
                            key={ssIdx}
                            className={DefinitionsCss.InptContainer}
                          >
                            <div
                              className={
                                DefinitionsCss.SubSubinptLabelContainer
                              }
                            >
                              <span className={DefinitionsCss.SubSubInptlabel}>
                                <CategoryRightArrow
                                  className={DefinitionsCss.editIconSize}
                                />
                                &nbsp; Sub - Sub Category Name
                              </span>
                              <span
                                className={DefinitionsCss.InptActionlabel}
                              ></span>
                            </div>
                            <div
                              className={
                                DefinitionsCss.subCategoryInptContainer
                              }
                            >
                              <input
                                className={DefinitionsCss.SubSubCategoryInpt}
                                type="text"
                                placeholder="Category Name"
                                value={ss}
                                onChange={(e) => {
                                  const newCats = [...categories];
                                  newCats[catIdx].subCategories[
                                    subIdx
                                  ].subSubCategories[ssIdx] = e.target.value;
                                  setCategories(newCats);
                                }}
                              />
                              <RemoveIcon
                                className={DefinitionsCss.removeIcon}
                                onClick={() =>
                                  removeSubSubCategory(catIdx, subIdx, ssIdx)
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}

                    <AddSubCategoryBtn onClick={() => addSubCategory(catIdx)} />
                  </div>
                </div>
              ))}

              <div className={DefinitionsCss.createCanelBtnContainer}>
                <div>
                  <button
                    className={`${DefinitionsCss.cancelStagingBtn}`}
                    type="button"
                    onClick={() => {
                      setCreateTab("I");
                    }}
                  >
                    Cancel
                  </button>
                  {createOrUpdate === "U" ? (
                    <button
                      className={`${DefinitionsCss.delBtn}`}
                      type="button"
                      onClick={() => getCategoryDataSendToApi("D")}
                    >
                      Delete Category
                    </button>
                  ) : null}
                </div>

                <button
                  className={`${DefinitionsCss.createStagingBtn}`}
                  type="button"
                  onClick={() =>
                    getCategoryDataSendToApi(
                      createOrUpdate // 'C' or 'U'
                    )
                  }
                >
                  {createOrUpdate === "C" ? "Create" : "Update"}
                </button>
              </div>
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

const AddSubCategoryBtn = ({ onClick }) => {
  return (
    <div
      className={DefinitionsCss.InptContainer}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <div className={DefinitionsCss.subCategoryInptContainer}>
        <div className={DefinitionsCss.AddSubCategoryInptBtn}>
          <AddCategoryBtn className={DefinitionsCss.editIconSize} />
          &nbsp; &nbsp; Add Sub Category
        </div>
      </div>
    </div>
  );
};

const AddSubSubCategoryBtn = ({ onClick }) => {
  return (
    <div
      className={DefinitionsCss.InptContainer}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <div className={DefinitionsCss.subCategoryInptContainer}>
        <div className={DefinitionsCss.AddSubSubCategoryInptBtn}>
          <AddCategoryBtn className={DefinitionsCss.editIconSize} />
          &nbsp; &nbsp; Add Sub - Sub Category
        </div>
      </div>
    </div>
  );
};

// const customStyles = {
//     control: (base, state) => ({
//         ...base,
//         borderRadius: '12.07px',
//         backgroundColor: '#F4FAF5',
//         border: '1px solid #C2E6D1',
//         color: '#4D6D64',
//         padding: '5.32px 14.49px',
//         boxShadow: 'none',
//         '&:hover': {
//         borderColor: '#C2E6D1',
//         },
//     }),
//     option: (base, state) => ({
//         ...base,
//         backgroundColor: state.isFocused ? '#C2E6D1' : '#FFFFFF',
//         color: '#4D6D64',
//         padding: '12px 16px',
//         cursor: 'pointer',
//         fontWeight: state.isSelected ? 'bold' : 'normal',
//     }),
//     menu: (base) => ({
//         ...base,
//         borderRadius: '12.07px',
//         marginTop: '5px',
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         border: '1px solid #C2E6D1',
//     }),
//     };

export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#f4faf5",
    borderColor: "#c2e6d1",
    color: "#b3c0bd",
    boxShadow: state.isFocused ? "0 0 0 1px #c2e6d1" : "none",
    borderWidth: "1px",
    borderRadius: "0.5rem",
    "&:hover": {
      borderColor: "#b3c0bd",
    },
    minHeight: "38px",
    height: "38px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 8px",
    paddingTop: "1px",
  }),
  input: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#4d6d64",
    fontSize: "14px",
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e0f5e9", // softer variant
    borderRadius: "0.25rem",
    border: "1px solid #c2e6d1",
    width: "fit-content",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#4d6d64",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      backgroundColor: "#c2e6d1",
      color: "#4f665f",
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: "#b3c0bd",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      color: "#4f665f",
    },
  }),
  clearIndicator: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    ":hover": {
      color: "#4f665f",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#f4faf5",
    border: "1px solid #c2e6d1",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
    borderRadius: "0.5rem",
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#c2e6d1"
      : state.isFocused
      ? "#e9f7ef"
      : "transparent",
    color: "#4f665f",
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "14px",
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    color: "#b3c0bd",
    padding: "8px 12px",
  }),
};
